import React from 'react';
import { StyledSpacer } from './Spacer.styled';

const Spacer: React.FC = () => {
    return <StyledSpacer />
};

export default Spacer;